import { Fade, IconButton, Modal, Typography, Box } from "@mui/material";
import React from "react";
import CancelIcon from "../../icons/Cancel";

const JobDataModal = ({
  children,
  openModal,
  handleClose,
  title,
}: {
  children: any;
  openModal: boolean;
  handleClose: () => void;
  title: string;
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    bgcolor: "background.paper",
    borderRadius: "16px",
    boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.25)",
    p: 4,
  };
  return (
    <Modal
      open={openModal}
      onClose={handleClose}
      closeAfterTransition
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={openModal}>
        <Box sx={style}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 2,
              top: 1,
            }}
          >
            <CancelIcon color="primary" size="medium" />
          </IconButton>

          <Typography
            variant="body1"
            sx={{
              fontSize: "18px",
              textAlign: "center",
              fontWeight: 600,
              color: "#000271",
              fontFamily: "Gilroy",
            }}
          >
            {title}
          </Typography>
          <Box
            sx={{
              border: "1px solid #A3A3A3",
              mt: 2,
              borderRadius: "8px",
              maxHeight: "350px",
              height: "350px",
              overflowY: "auto",
            }}
          >
            <pre>{JSON.stringify(children, null, 2)}</pre>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default JobDataModal;
